import { render, staticRenderFns } from "./lrModifytime.vue?vue&type=template&id=04bd0040&"
import script from "./lrModifytime.vue?vue&type=script&lang=js&"
export * from "./lrModifytime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports